import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { ActionFailed, RentalService, Toaster } from '@tokeet-frontend/tv3-platform'
import { GuestService } from '@tv3/store/guest/guest.service'
import { InquiryService } from '@tv3/store/inquiry/inquiry.service'
import { InvoiceService } from '@tokeet-frontend/invoices'

import { Notification, NotificationLinkTypes } from '../store/notification/notification.model'
import {
  OpenEditHoldDialog,
  OpenGuestOverlay,
  OpenInquiryOverlay,
  OpenInvoiceOverlay,
  OpenRentalOverlay,
} from '../store/overlay/overlay.actions'
import * as fromRoot from '../store/state'
import { ContractDrawerService } from '@tv3/containers/documents/contracts/contract-drawer/contract-drawer.service'
import { CalendarService } from '@tv3/store/calendar/calendar.service'

@Injectable({
  providedIn: 'root',
})
export class NotificationDetailService {
  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private toaster: Toaster,
    private inquiryService: InquiryService,
    private invoiceService: InvoiceService,
    private guestService: GuestService,
    private rentalService: RentalService,
    private contractDrawer: ContractDrawerService,
    private calendarService: CalendarService
  ) {}

  tryToOpenInquiryDetail(id: string) {
    this.inquiryService.loadPreview(id).subscribe(
      () => {
        this.store.dispatch(OpenInquiryOverlay({ inquiryId: id }))
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  tryToOpenInvoiceDetail(id: string) {
    this.invoiceService.get(id).subscribe(
      () => {
        this.store.dispatch(OpenInvoiceOverlay({ invoiceId: id }))
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  tryToOpenGuestDetail(id: string) {
    this.guestService.get(id).subscribe(
      () => {
        this.store.dispatch(OpenGuestOverlay({ guestId: id }))
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  tryToOpenRentalDetail(id: string) {
    this.rentalService.get(id).subscribe(
      (rental) => {
        this.store.dispatch(OpenRentalOverlay({ rental }))
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  tryToOpenHoldEventDetail(id: string) {
    this.calendarService.get(id).subscribe(
      (hold) => {
        this.store.dispatch(OpenEditHoldDialog({ data: { hold } }))
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  openDetail(notification: Notification) {
    switch (notification.linkType) {
      case NotificationLinkTypes.Inquiry:
      case NotificationLinkTypes.Booking:
        this.tryToOpenInquiryDetail(notification.linkId)
        break
      case NotificationLinkTypes.Contract:
        this.contractDrawer.open(notification.linkId)
        break
      case NotificationLinkTypes.Invoice:
        this.tryToOpenInvoiceDetail(notification.linkId)
        break
      case NotificationLinkTypes.Guest:
        this.tryToOpenGuestDetail(notification.guestId)
        break
      case NotificationLinkTypes.Rental:
        this.tryToOpenRentalDetail(notification.rentalId)
        break
      case NotificationLinkTypes.HoldEvent:
        this.tryToOpenHoldEventDetail(notification.linkId)
      default:
        break
    }
  }
}
